<template>
    <div id="root" class="root">
        <nav id="sidebar">
            <div class="sidebar-header" style="font-size: 1.1em; display: flex; align-items: center;">
                <div style="width: 100%; text-align: center;" @click="selectMenu(0)">
                    <img src="/static/imgs/logols_w.svg" alt="menu" style="width: 30%; margin-top: 5vh; margin-bottom: 2.5vh;">
                </div>
            </div>
            <ul class="list-unstyled components" style="margin-top: 0; overflow-y: scroll; font-size: 4vw;">
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(6)">RESERVAS</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(1)">HISTÓRIA</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(2)">COMODIDADES</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(3)">LOCALIZAÇÃO</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(4)">GASTRONOMIA</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(5)">ACOMODAÇÕES</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(7)">LS EXPERIENCE</a>
                </li>
            </ul>
        </nav>

        <div class="section" id="sidebarCollapse" @click="changeSideBar()">
            <a class="navicon-button x" id="icmenu" >
                <div class="navicon">
                </div>
            </a>
        </div>

        <div class="top-bar" :style="'margin-top: ' + topBarMargin + 'px;'">
            <span class="top-bar-item" @click="selectMenu(6)">RESERVAS</span>
            <span class="top-bar-item" @click="selectMenu(1)">HISTÓRIA</span>
            <span class="top-bar-item" @click="selectMenu(2)">COMODIDADES</span>
            <span class="top-bar-item" @click="selectMenu(3)">LOCALIZAÇÃO</span>
            <img class="top-logo" :style="'height: ' + logoHeight + 'vh; margin-top: ' + logoMargin + 'vh;'" src="/static/imgs/logols.svg" @click="selectMenu(0)"/>
            <span class="top-bar-item" @click="selectMenu(4)">GASTRONOMIA</span>
            <span class="top-bar-item" @click="selectMenu(5)">ACOMODAÇÕES</span>
            <span class="top-bar-item" @click="selectMenu(7)">LS EXPERIENCE</span>
            <div class="top-bar-item">
                <a target="_blank" href="https://www.facebook.com/lshoteljp/"><img src="/static/imgs/ic_r_face_y.svg"/></a>
                <a target="_blank" href="https://www.instagram.com/ls_hotel/"><img src="/static/imgs/ic_r_insta_y.png"/></a>
                <a target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g303428-d15241822-Reviews-Ls_Hotel-Joao_Pessoa_State_of_Paraiba.html"><img src="/static/imgs/ic_r_trip_y.png"/></a>
            </div>
        </div>

        <!-- ################ HOME  ################ -->
        <div id="part0" class="home">
            <!--<img class="im_slider" src="/static/imgs/bg_home01.jpg"/>-->

            <div class="slider">
                <!--<div class="div_arrow" style="left: 0; position: absolute" @click.prevent="moveSlide(1, false)">-->
                    <!--<img src='/static/imgs/ic_seta.svg' style="padding-left: 1vw" class="im_arrow"/>-->
                <!--</div>-->
                <!--<div class="div_arrow" @click.prevent="moveSlide(1, true)">-->
                    <!--<img src='/static/imgs/ic_seta.svg' style="padding-right: 1vw; transform: rotate(180deg)" class="im_arrow"/>-->
                <!--</div>-->

                <div class="slide1">
                    <div class="img_container" :style="'background-image: url(' + slide_home[0] + ');'">
                    </div>
                </div>

                <div class="slide1 active">
                    <div class="img_container" :style="'display: flex; text-align: center; background-image: url(' + slide_home[1] + ');'">
                    </div>
                </div>

                <div class="slide1">
                    <div class="img_container" :style="'background-image: url(' + slide_home[2] + ');'">
                    </div>
                </div>

                <div class="slide1">
                    <div class="img_container" :style="'background-image: url(' + slide_home[3] + ');'">
                    </div>
                </div>

                <!--Quando tem o reveillon-->
                <!--<div class="slide1">-->
                    <!--<div class="img_container" :style="'background-image: url(' + slide_home[4] + ');'">-->
                    <!--</div>-->
                <!--</div>-->
            </div>

            <div class="dv_home_selos">
                <img class="im_selo" src="/static/imgs/selo_booking.png"/>
                <img class="im_selo" src="/static/imgs/selo_tripadvisor.png"/>
                <img class="im_selo" src="/static/imgs/selo_tripadvisor2.jpg"/>
                <img class="im_selo" src="/static/imgs/selo_tripadvisor2022.svg"/>
                <a target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g303428-d15241822-Reviews-Ls_Hotel-Joao_Pessoa_State_of_Paraiba.html">
                    <img class="im_selo" src="/static/imgs/selo_tripadvisor2023.png"/>
                </a>
                <a target="_blank" href="https://connect.gptw.info/certified-company?s=81b2c5cb-8dcd-49f4-9bce-d70a6d541d4e">
                    <img class="im_selo" src="/static/imgs/selo_gptw_.png"/>
                </a>

            </div>
        </div>

        <!-- ################ RESERVAS  ################ -->
        <div id="part6" class="reservas">
            <div class="dv_reservas_tit_cont">
                <span class="tx_title_reservas">Reservas</span>
                <div class="dv_reservas_divisor"/>
                <div class="dv_reservas_texto">
                    <span class="tx_descricao" style="font-size: 1.6vh; line-height: 3.5vh;">Venha viver a experiência LS Hotel.</span>
                    <span class="tx_descricao" style="font-size: 1.6vh; line-height: 3.5vh;">Preencha os campos abaixo e garanta a sua reserva. Estamos à disposição para lhe</span>
                    <span class="tx_descricao" style="font-size: 1.6vh; line-height: 3.5vh;">proporcionar uma estada exclusiva, personalizada e inesquecível.</span>
                </div>
            </div>

            <div class="dv_reservas_container">
                <div class="dv_colum_reservas">
                    <span class="tx_reservas1">CHECK-IN</span>
                    <div class="dv_box_calendar">

                        <div>
                            <img src="/static/imgs/ic_arrow_left.svg" style="width:3vh; height: 3vh;" @click="getMes(calendario1, -1)"/>
                            <span class="tx_reservas3"> {{ getMes(calendario1, 0) }} </span>
                            <img src="/static/imgs/ic_arrow_left.svg" style="width:3vh; height: 3vh; transform: rotate(180deg);" @click="getMes(calendario1, 1)"/>
                        </div>

                        <table style="width:100%">
                            <tr>
                                <th class="tb_reserva_sem" v-for="(sem, index) in semanas" :key="index">{{ sem }}</th>
                            </tr>
                            <tr v-for="row in 6" :key="row">
                                <th :id="'1,' + row + ',' + col" class="tb_reserva" v-for="col in 7" :key="col" @click="selectDay(1, row, col)">{{ calendario1.matrix[row-1][col-1].dia }}</th>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="dv_colum_reservas">
                    <span class="tx_reservas1">CHECK-OUT</span>
                    <div class="dv_box_calendar">
                        <div>
                            <img src="/static/imgs/ic_arrow_left.svg" style="width:3vh; height: 3vh;" @click="getMes(calendario2, -1)"/>
                            <span class="tx_reservas3"> {{ getMes(calendario2, 0) }} </span>
                            <img src="/static/imgs/ic_arrow_left.svg" style="width:3vh; height: 3vh; transform: rotate(180deg);" @click="getMes(calendario2, 1)"/>
                        </div>

                        <table style="width:100%">
                            <tr>
                                <th class="tb_reserva_sem" v-for="(sem, index) in semanas" :key="index">{{ sem }}</th>
                            </tr>
                            <tr v-for="row in 6" :key="row">
                                <th :id="'2,' + row + ',' + col" class="tb_reserva" v-for="col in 7" :key="col" @click="selectDay(2, row, col)">{{ calendario2.matrix[row-1][col-1].dia }}</th>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="dv_colum_reservas" style="text-align: left;">
                    <span class="tx_reservas1">&nbsp;</span>
                    <div class="dv_box_calendar" style="display: flex; flex-direction: column; justify-content: space-between; border-style: none;">
                        <div>
                            <span class="tx_reservas1" style="margin-right: 2vw;">ADULTOS</span>
                            <select class="sel_reservas" v-model="quantAdultos">
                                <option value="0"> 0 </option>
                                <option value="1"> 1 </option>
                                <option value="2"> 2 </option>
                                <option value="3"> 3 </option>
                                <option value="4"> 4 </option>
                                <option value="5"> 5 </option>
                            </select>
                        </div>
                        <div>
                            <span class="tx_reservas1" style="margin-right: 2vw;">CRIANÇAS</span>
                            <select class="sel_reservas" v-model="quantCriancas">
                                <option value="0"> 0 </option>
                                <option value="1"> 1 </option>
                                <option value="2"> 2 </option>
                                <option value="3"> 3 </option>
                                <option value="4"> 4 </option>
                                <option value="5"> 5 </option>
                            </select>
                        </div>
                        <div>
                            <span class="tx_reservas1" style="margin-right: 2vw;">SUÍTE</span>
                            <select class="sel_reservas2"  v-model="tipoSuite">
                                <option value="0"> DELUXE </option>
                                <option value="1"> PREMIUM </option>
                                <option value="2"> PRESIDENCIAL </option>
                            </select>
                        </div>
                        <div>
                            <span class="tx_reservas2" @click="reservar()">RESERVAR</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ################ HISTORIA  ################ -->
        <div id="part1" class="historia">
            <div style="width: 100%; height: 1vh; display: flex; flex-direction: row;">
                <div style="width: 25%; height: 100%; background-color: #7d6125;"/>
                <div style="width: 25%; height: 100%;"/>
                <div style="width: 25%; height: 100%; background-color: var(--light-gray-font);"/>
                <div style="width: 25%; height: 100%; background-color: var(--dark-gray);"/>
            </div>
            <div class="dv_historia">
                <div class="dv_historia_sub1">
                    <img class="im_historia" src="/static/imgs/im_historia.jpg"/>
                </div>
                <div class="dv_historia_sub2">
                    <span class="tx_title_historia">A arte de receber bem</span>
                    <span class="tx_descricao">{{ tx_historia }}</span>
                </div>
            </div>
        </div>

        <!-- ################ COMODIDADES  ################ -->
        <div id="part2" class="comodidades">
            <div class="dv_row_comodidades_container_ft">
                <div class="dv_row_comodidades_container">
                    <span class="tx_title_comodidades" >Comodidades</span>
                    <div class="dv_gastro_divisor"/>
                    <span class="tx_subtitle_comodidade">Serviços diferenciados para experiência completas.</span>
                </div>
            </div>

            <div class="dv_colum_comodidades_container">
                <div class="dv_colum_comodidades">
                    <div class="dv_line_comodidades">
                        <img class="im_ic_comodidades" src="/static/imgs/ic_internet.svg"/>
                        <div style="display: flex; flex-direction: column;">
                            <span class="tx_comodidades_title">INTERNET</span>
                            <span class="tx_comodidades_desc">Acesso gratuito</span>
                        </div>
                    </div>
                    <div class="dv_line_comodidades">
                        <img class="im_ic_comodidades" src="/static/imgs/ic_piscina.svg"/>
                        <div style="display: flex; flex-direction: column;">
                            <span class="tx_comodidades_title">ROOFTOP</span>
<!--                            <span class="tx_comodidades_desc"><span style="font-weight: bold">Pez no rooftop</span> - aberto diariamente</span>-->
<!--                            <span class="tx_comodidades_desc" style="margin-top: 1vh;">De domingo a quarta:</span>-->
<!--                            <span class="tx_comodidades_desc">das 11h às 14h30 (exclusivo para hóspedes)</span>-->
<!--                            <span class="tx_comodidades_desc" style="margin-top: 1vh;">De quinta a sábado:</span>-->
<!--                            <span class="tx_comodidades_desc">das 11h às 14h30 (exclusivo para hóspedes)</span>-->
<!--                            <span class="tx_comodidades_desc">das 18h às 00h (mediante reserva e aberto ao público)</span>-->
<!--                            <span class="tx_comodidades_desc" style="margin-top: 1vh; font-weight: bold">Piscina</span>-->
                            <span class="tx_comodidades_desc"><span style="font-weight: bold">Pez no rooftop</span> - aberto diariamente</span>
                            <span class="tx_comodidades_desc" style="margin-top: 1vh;">Domingo a quinta-feira:</span>
                            <span class="tx_comodidades_desc">das 10h às 18h</span>
                            <span class="tx_comodidades_desc" style="margin-top: 1vh;">Sexta-feira a sábado:</span>
                            <span class="tx_comodidades_desc">das 11h às 20h</span>
                            <span class="tx_comodidades_desc" style="margin-top: 2vh; font-weight: bold">Piscina</span>
                        </div>
                    </div>
                    <div class="dv_line_comodidades">
                        <img class="im_ic_comodidades" src="/static/imgs/ic_bemestar.svg"/>
                        <div style="display: flex; flex-direction: column;">
                            <span class="tx_comodidades_title">BEM-ESTAR</span>
                            <span class="tx_comodidades_desc">&bull; Academia</span>
                            <span class="tx_comodidades_desc">&bull; Spa (mediante reserva e exclusivo para hóspedes)</span>
                        </div>
                    </div>
                </div>

                <div class="dv_colum_comodidades">
                    <div class="dv_line_comodidades">
                        <img class="im_ic_comodidades" src="/static/imgs/ic_estacionamento.svg"/>
                        <div style="display: flex; flex-direction: column;">
                            <span class="tx_comodidades_title">ESTACIONAMENTO</span>
                            <span class="tx_comodidades_desc">&bull; Privativo e gratuito</span>
<!--                            <span class="tx_comodidades_desc">&bull; Ponto de carregamento para carros elétricos</span>-->
                        </div>
                    </div>
                    <div class="dv_line_comodidades">
                        <img class="im_ic_comodidades" src="/static/imgs/ic_alimentos.svg"/>
                        <div style="display: flex; flex-direction: column;">
                            <span class="tx_comodidades_title">ALIMENTOS E BEBIDAS</span>
                            <span class="tx_comodidades_desc">&bull; Restaurante Adega</span>
                            <span class="tx_comodidades_desc">&bull; Bar da Adega no Lobby</span>
                            <span class="tx_comodidades_desc">&bull; PEZ no Rooftop</span>
<!--                            <span class="tx_comodidades_desc">&bull; Nonno Cucina anexo ao LS Hotel</span>-->
                            <span class="tx_comodidades_desc">&bull; Café da manhã no quarto sob consulta</span>
                            <span class="tx_comodidades_desc">&bull; Café da manhã no quarto sob consulta</span>
                            <span class="tx_comodidades_desc">&bull; Room Service</span>
                        </div>
                    </div>
                    <div class="dv_line_comodidades">
                        <img class="im_ic_comodidades" src="/static/imgs/ic_eventos.svg"/>
                        <div style="display: flex; flex-direction: column;">
                            <span class="tx_comodidades_title">EVENTOS</span>
                            <span class="tx_comodidades_desc">Amplos espaços para eventos, reuniões, jantares e celebrações</span>
                        </div>
                    </div>
                </div>

                <div class="dv_colum_comodidades">
                    <div class="dv_line_comodidades">
                        <img class="im_ic_comodidades" src="/static/imgs/ic_concierge.svg"/>
                        <div style="display: flex; flex-direction: column;">
                            <span class="tx_comodidades_title">CONCIERGE</span>
                            <span class="tx_comodidades_desc">&bull; Welcome drink de boas-vindas</span>
                            <span class="tx_comodidades_desc">&bull; Programações musicais no hotel</span>
                            <span class="tx_comodidades_desc">&bull; Aluguel de bicicleta</span>
                            <span class="tx_comodidades_desc">&bull; Jantares românticos sob consulta</span>
                            <span
                                class="tx_comodidades_desc">&bull; Roteiros turísticos, gastronômicos e culturais</span>
                        </div>
                    </div>
                    <div class="dv_line_comodidades">
                        <img class="im_ic_comodidades" src="/static/imgs/ic_recepacao.svg"/>
                        <div style="display: flex; flex-direction: column;">
                            <span class="tx_comodidades_title">RECEPÇÃO</span>
                            <span class="tx_comodidades_desc">&bull; Pré check-in (<a href="https://easycheckin.vegait.com.br/ls-hotel/ls-hotel" target="_blank" style="color: blue;">clique aqui para fazer o seu</a>)</span>

                            <span class="tx_comodidades_desc">&bull; Check-in às 14h e check-out às 12h</span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; width: 100%; height: auto; flex-grow: 1; align-items: flex-end;">
                <div style="background-color: var(--light-brown); height: 5vh; width: 100%;"/>
            </div>
        </div>

        <!-- ################ LOCALIZACAO  ################ -->
        <div id="part3" class="localizacao">
            <div class="dv_localizacao_container">
                <div class="dv_localizacao_sub1">
                    <div
                        style="height: 65%; width: 100%; background-color: var(--dark-gray); display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        <span class="tx_title_localizacao">Localização</span>
                        <span class="tx_descricao" style="text-align: center; color: var(--light-gray-font); font-size: 1.8vh; line-height: 4vh; width: 80%;">{{ tx_localizacao }}</span>
                    </div>
                    <img style="height: 8%; margin-top: -7%;" src="/static/imgs/ic_pin.svg"/>
                    <div style="height: 30%; width: 100%; display: flex; flex-direction: column; justify-content: center; margin-top: -2%;">
                        <span class="tx_endereco">Avenida Ingá, 92 - Manaíra</span>
                        <span class="tx_endereco">João Pessoa | Paraíba | Brasil</span>
                        <span class="tx_endereco">CEP: 58038-250</span>
                    </div>
                </div>

                <div class="dv_localizacao_sub2">
                    <iframe width="100%" height="100%" id="gmap_canvas"
                        src="https://maps.google.com/maps?q=LS%20Hotel%2C%20Avenida%20Inga%2C%2092%20-%20Mana%C3%ADra&t=&z=18&ie=UTF8&iwloc=&output=embed"
                        frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                </div>
            </div>
        </div>

        <!-- ################ GASTRONOMIA  ################ -->
        <div id="part4" class="gastronomia">
            <div class="dv_row_gastronomia_container_ft">
                <div class="dv_row_gastronomia_container">
                    <span class="tx_title_gastro" style="color: var(--light-yellow); margin-bottom: -2vh; font-size: 7vh;">Gastronomia</span>
                    <div class="dv_gastro_divisor"/>
                    <span class="tx_descricao_gastro" >Conheça os restaurantes que compõem a experiência LS Hotel.</span>
                </div>
            </div>
            <div class="dv_colum_gastronomia_container">
                <div class="dv_colum_gastronomia">
                    <!--<span v-if="sel_rest == 1" class="tx_gastronomia_title_s" @click.stop.prevent="selectRestaurante(1)">IPPON</span>-->
                    <span class="tx_gastronomia_title" @click.stop.prevent="selectRestaurante(1)">IPPON</span>

                    <div class="dv_gastronomia" @click.stop.prevent="selectRestaurante(1)">
                        <div class="dv_gastronomia_overlay">
                            <span class="tx_descricao" style="width: 80%; text-align: center; font-size: 1.8vh; line-height: 3.5vh;"> {{ tx_ippon }}</span>
                            <div style="width: 8vw; height: 2px; background-color: var(--light-brown); margin-top: 4vh; margin-bottom: 4vh;"></div>
                            <span class="tx_social_gastronomia" @click="goToURL('https://www.instagram.com/ipponrestaurante/')">INSTAGRAM</span>
                            <!--<span class="tx_social_gastronomia" @click="goToURL('https://www.facebook.com/lshoteljp/')">FACEBOOK</span>-->
                            <span class="tx_social_gastronomia" @click="goToURL('https://www.tripadvisor.com.br/Restaurant_Review-g303428-d5973022-Reviews-Ippon-Joao_Pessoa_State_of_Paraiba.html')">TRIPADVISOR</span>
                        </div>
                    </div>
                </div>
                <div class="dv_colum_gastronomia">
                    <!--<span v-if="sel_rest == 2" class="tx_gastronomia_title_s" @click.stop.prevent="selectRestaurante(2)">ADEGA RESTAURANTE</span>-->
                    <span class="tx_gastronomia_title" @click.stop.prevent="selectRestaurante(2)">ADEGA RESTAURANTE</span>

                    <div class="dv_gastronomia" style="background-image: url('/static/imgs/im_rest02.jpg');" @click.stop.prevent="selectRestaurante(2)">
                        <div class="dv_gastronomia_overlay">
                            <span class="tx_descricao" style="width: 80%; text-align: center; font-size: 1.8vh; line-height: 3.5vh;"> {{ tx_adega }}</span>
                            <div style="width: 8vw; height: 2px; background-color: var(--light-brown); margin-top: 4vh; margin-bottom: 4vh;"></div>
                            <span class="tx_social_gastronomia" @click="goToURL('https://www.instagram.com/adega.restaurante/')">INSTAGRAM</span>
                            <!--<span class="tx_social_gastronomia" @click="goToURL('https://www.facebook.com/lshoteljp/')">FACEBOOK</span>-->
                            <span class="tx_social_gastronomia" @click="goToURL('https://www.tripadvisor.com.br/Restaurant_Review-g303428-d15640400-Reviews-Adega_Restaurante-Joao_Pessoa_State_of_Paraiba.html')">TRIPADVISOR</span>
                        </div>
                    </div>
                </div>
<!--                <div class="dv_colum_gastronomia">-->
<!--                    <span class="tx_gastronomia_title" @click.stop.prevent="selectRestaurante(3)">NONNO CUCINA</span>-->

<!--                    <div class="dv_gastronomia" style="background-image: url('/static/imgs/im_rest04.jpg');" @click.stop.prevent="selectRestaurante(3)">-->
<!--                        <div class="dv_gastronomia_overlay">-->
<!--                            <span class="tx_descricao" style="width: 80%; text-align: center; font-size: 1.8vh; line-height: 3.5vh;"> {{ tx_nonno }}</span>-->
<!--                            <div style="width: 8vw; height: 2px; background-color: var(&#45;&#45;light-brown); margin-top: 4vh; margin-bottom: 4vh;"></div>-->
<!--                            <span class="tx_social_gastronomia" @click="goToURL('https://www.instagram.com/nonno_cucina/')">INSTAGRAM</span>-->
<!--                            &lt;!&ndash;<span class="tx_social_gastronomia" @click="goToURL('https://www.facebook.com/lshoteljp/')">FACEBOOK</span>&ndash;&gt;-->
<!--                            <span class="tx_social_gastronomia" @click="goToURL('https://www.tripadvisor.com.br/Restaurant_Review-g303428-d23542707-Reviews-Nonno_Cucina-Joao_Pessoa_State_of_Paraiba.html')">TRIPADVISOR</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="dv_colum_gastronomia">
                    <span class="tx_gastronomia_title" @click.stop.prevent="selectRestaurante(4)">PEZ NO ROFTOP</span>

                    <div class="dv_gastronomia" style="background-image: url('/static/imgs/im_rest05.jpg');" @click.stop.prevent="selectRestaurante(4)">
                        <div class="dv_gastronomia_overlay">
                            <span class="tx_descricao" style="width: 80%; text-align: center; font-size: 1.8vh; line-height: 3.5vh;"> {{ tx_pez }}</span>
                            <div style="width: 8vw; height: 2px; background-color: var(--light-brown); margin-top: 4vh; margin-bottom: 4vh;"></div>
                            <span class="tx_social_gastronomia" @click="goToURL('https://www.instagram.com/pez_lounge/')">INSTAGRAM</span>
                            <!--<span class="tx_social_gastronomia" @click="goToURL('https://www.facebook.com/lshoteljp/')">FACEBOOK</span>-->
                            <!--<span class="tx_social_gastronomia" @click="goToURL('https://www.tripadvisor.com.br/Restaurant_Review-g303428-d23542707-Reviews-Nonno_Cucina-Joao_Pessoa_State_of_Paraiba.html')">TRIPADVISOR</span>-->
                        </div>
                    </div>
                </div>
                <div class="dv_colum_gastronomia3">
                    <span class="tx_gastronomia_title" @click.stop.prevent="selectRestaurante(5)">CASSINO DA LAGOA</span>

                    <div class="dv_gastronomia" style="background-image: url('/static/imgs/im_rest06.jpg');" @click.stop.prevent="selectRestaurante(5)">
                        <div class="dv_gastronomia_overlay">
                            <span class="tx_descricao" style="width: 80%; text-align: center; font-size: 1.8vh; line-height: 3.5vh;"> {{ tx_cassino }}</span>
                            <div style="width: 8vw; height: 2px; background-color: var(--light-brown); margin-top: 4vh; margin-bottom: 4vh;"></div>
                            <span class="tx_social_gastronomia" @click="goToURL('https://www.instagram.com/cassinodalagoa/')">INSTAGRAM</span>
                            <!--<span class="tx_social_gastronomia" @click="goToURL('https://www.facebook.com/lshoteljp/')">FACEBOOK</span>-->
                            <!--<span class="tx_social_gastronomia" @click="goToURL('https://www.tripadvisor.com.br/Restaurant_Review-g303428-d23542707-Reviews-Nonno_Cucina-Joao_Pessoa_State_of_Paraiba.html')">TRIPADVISOR</span>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ################ ACOMODACOES  ################ -->
        <div id="part5" class="acomodacoes">
            <div class="dv_acomodacoes_tit_cont">
                <div class="dv_row_acomodacoes_container_ft" >
                    <div class="dv_row_acomodacoes_container" >
                        <span class="tx_title_acomoda">Acomodações</span>
                        <span class="tx_subtitle_acomoda" >Um convite ao bem-estar.</span>
                    </div>
                </div>
                <span v-if="sel_acomodacao == 1" class="tx_acomodacaoes_subtitle_s" @click="selectAcomodacao(1)">DELUXE</span>
                <span v-else class="tx_acomodacaoes_subtitle" @click="selectAcomodacao(1)">DELUXE</span>
                <span v-if="sel_acomodacao == 2" class="tx_acomodacaoes_subtitle_s" @click="selectAcomodacao(2)">PREMIUM</span>
                <span v-else class="tx_acomodacaoes_subtitle" @click="selectAcomodacao(2)">PREMIUM</span>
                <span v-if="sel_acomodacao == 3" class="tx_acomodacaoes_subtitle_s" @click="selectAcomodacao(3)">PRESIDENCIAL</span>
                <span v-else class="tx_acomodacaoes_subtitle" @click="selectAcomodacao(3)">PRESIDENCIAL</span>
            </div>
            <div class="dv_acomodacoes_container">
                <div class="dv_acomodacoes_sub1" >

                    <div class="slider">
                        <div class="div_arrow" style="left: 0; position: absolute" @click.prevent="moveSlide(2, false)">
                            <img src='/static/imgs/ic_seta.svg' class="im_arrow"/>
                        </div>
                        <div class="div_arrow" @click.prevent="moveSlide(2, true)">
                            <img src='/static/imgs/ic_seta.svg' style="transform: rotate(180deg);" class="im_arrow"/>
                        </div>

                        <div class="slide2">
                            <div class="img_container" :style="'background-image: url(' + slide_suites[0] + ');'">
                            </div>
                        </div>

                        <div class="slide2 active">
                            <div class="img_container" :style="'display: flex; text-align: center; background-image: url(' + slide_suites[1] + ');'">
                            </div>
                        </div>

                        <div class="slide2">
                            <div class="img_container" :style="'background-image: url(' + slide_suites[2] + ');'">
                            </div>
                        </div>
                    </div>

                </div>
                <div class="dv_descricao_acomoda" >
                    <span v-if="sel_acomodacao == 1" class="tx_descricao_acomoda">{{ tx_deluxe }}</span>
                    <span v-if="sel_acomodacao == 2" class="tx_descricao_acomoda">{{ tx_premium }}</span>
                    <span v-if="sel_acomodacao == 3" class="tx_descricao_acomoda" style="height: 80vh; min-height: 100vh !important">{{ tx_presidencial }}</span>
                    <div style="display: flex; height: 70vh; min-height: 70vh; width: 100%; flex-direction: column; justify-content: center; align-items: center; align-content: center;">
                        <span class="tx_descricao_acomoda_topics">&bull; Cama padrão internacional</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Televisor 40" HD</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Canais de TV a cabo</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Mesa de trabalho</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Mini bar com máquina de café</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Móveis sob medida</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Ar-condicionado</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Espaço de banho com ducha de alta pressão</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Isolamento acústico</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Conexão wi-fi de alta velocidade</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Cofre eletrônico</span>
                        <span class="tx_descricao_acomoda_topics">&bull; Fechadura eletrônica</span>
                    </div>
                </div>
            </div>
            <div style="width: 100%; height: 10vh; background-image: url('/static/imgs/bg_cinza_hd.jpg'); background-position: initial; background-size: cover;">
            </div>
        </div>

        <!-- Fale Conosco -->
        <div id="part6_2" class="faleconosco">
            <span class="tx_title_newsletter" style="color: black;">Fale Conosco</span>
            <div id="faleconosco_ct" style="width: 90%; max-width: 90%; height: 100%;">
            </div>
        </div>

        <!-- Newsletter -->
        <div id="part6_3" class="newsletter">
            <span class="tx_title_newsletter" style="color: black;">Newsletter</span>
            <div id="newsletter_ct" style="width: 90%; height: 100%;">
            </div>
        </div>

        <!-- ################ FOOTBAR  ################ -->
        <div id="part7" class="footbar">
            <div class="dv_footbar_container">
                <div class="dv_footbar_colum0">
                    <span class="tx_footbar">CONTATO</span>
                    <span class="tx_footbar_desc"><a href="tel:+558330222460">+55 83 3022.2460</a></span>
                    <span class="tx_footbar_desc"><a target="_blank" href="https://api.whatsapp.com/send?phone=5583991951687">WhatsApp +55 83 9195-1687</a></span>
                    <span class="tx_footbar_desc"><a target="_blank" href="mailto:gerencia@lshotel.com.br">gerencia@lshotel.com.br</a></span>
                    <span class="tx_footbar_desc">Av. Ingá, 92 - Manaíra</span>
                    <span class="tx_footbar_desc">João Pessoa - Paraíba</span>
                </div>
                <div class="dv_footbar_colum">
                    <span class="tx_footbar" style="justify-content: center;">REDES SOCIAIS</span>
                    <div style="display: flex; align-self: center; justify-self: center; width: 100%; justify-content: center; margin-top: 5%;">
                        <a target="_blank" href="https://www.facebook.com/lshoteljp/"><img class="im_social" src="/static/imgs/ic_r_face_w.svg"/></a>
                        <a target="_blank" href="https://www.instagram.com/ls_hotel/"><img class="im_social" src="/static/imgs/ic_r_insta_w.svg"/></a>
                        <a target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g303428-d15241822-Reviews-Ls_Hotel-Joao_Pessoa_State_of_Paraiba.html"><img class="im_social" src="/static/imgs/ic_r_trip_w.svg"/></a>
                        <a target="_blank" href="https://api.whatsapp.com/send?phone=5583991951687"><img class="im_social" src="/static/imgs/ic_whatsapp.svg"/></a>
                    </div>
                </div>
                <!--<div class="dv_footbar_colum2" style="width: 23%;">-->
                    <!--<span class="tx_footbar">FAÇA PARTE DO NOSSO MAILLING</span>-->
                    <!--<input style="max-width: 100%; height: 2.5vh; margin-right: 0;" v-model="new_email" :placeholder="tx_digite_email" v-on:keyup.enter="closeKey()" onsubmit="closeKey()"/>-->
                    <!--<div style="text-align: right; width: 100%;">-->
                        <!--<span class="bt_enviar" @click="sendNewsletter()">ENVIAR</span>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="dv_footbar_colum2" style="align-items: center; justify-content: center;">
                    <img class="top-logo" src="/static/imgs/logols_w.svg" @click="selectMenu(0)"/>
                </div>
            </div>

            <div style="width: 100%; height: 1vh; display: flex; flex-direction: row;">
                <div style="width: 25%; height: 100%; background-color: #7d6125;"/>
                <div style="width: 25%; height: 100%; background-color: var(--light-yellow);"/>
                <div style="width: 25%; height: 100%; background-color: var(--light-gray-font);"/>
                <div style="width: 25%; height: 100%; background-color: var(--dark-gray);"/>
            </div>

        </div>

        <!-- WHATSAPP -->
        <img class="im_whats_over" @click.prevent.stop="callWhatsApp()" src="/static/imgs/ic_whats.png" />

        <div v-if="showPopup || showPopup2 || showPopup3 || showImagePopup" class="popup_overlay" @click.prevent.stop="closePopup()">
            <div v-if="showImagePopup" class="dv_popup_image" style="align-items: center;" @click.prevent.stop="closePopup()">
                <!--<img src="/static/imgs/pop_news.jpg" style="object-fit: contain; width: 100%; height: 100%" @click="selectMenu(6, false)"/>-->
                <!--<img src="/static/imgs/pop_incrivel.jpg" style="object-fit: contain; width: 100%; height: 100%" @click="selectMenu(7, false)"/>-->
                <!--<img src="/static/imgs/pop_carnaval2024.jpg" class="im_pop" style="object-fit: contain; height: 100%;" @click="goToURL('mailto:reservas@lshotel.com.br')"/>-->
                <!--<img src="/static/imgs/pop_maes2024.jpg" style="object-fit: contain; width: 100%; height: 100%" @click="selectMenu(6, false)"/>-->
                <img src="/static/imgs/pop_sunset.jpg" style="object-fit: contain; width: 100%; box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.5);" @click="selectMenu(6, false)"/>
            </div>

            <div id="popup1_ct" v-if="showPopup" class="dv_popup_mail" onclick="event.stopPropagation();">
                <!--<div style="display: flex; width: 100%; justify-content: flex-end;">-->
                    <!--<div style="width: 3vh; height: 3vh; margin-bottom: -3vh; z-index: 20; cursor: pointer;" @click.prevent.stop="closePopup()">-->
                        <!--<img src="/static/imgs/ic_fechar.svg" style="background-color: var(&#45;&#45;dark-brown-font); width: 100%; height: 100%; padding: 0.5vh; margin-left: -0.5vh; margin-top: -0.5vh;"/>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div style="border-width: 2px; border-style: solid; border-color: var(&#45;&#45;light-yellow); height: calc(100% - 4vh); text-align: left; padding: 2vh; display: flex; flex-direction: column; justify-content: space-between;">-->
                    <!--<div>-->
                        <!--<span class="tx_popup1">FAÇA PARTE DO</span>-->
                        <!--<div>-->
                            <!--<span class="tx_popup1">NOSSO</span>-->
                            <!--<span class="tx_popup2">MAILLING</span>-->
                        <!--</div>-->
                    <!--</div>-->

                    <!--<span class="tx_popup3">E receba com exclusividade nossos programas e pacotes especiais.</span>-->
                    <!--&lt;!&ndash;<form id="form_popup1">&ndash;&gt;-->
                        <!--<input class="ipt_popup" :placeholder="tx_digite_email" v-model="new_email" v-on:keyup.enter="closeKey()" onsubmit="closeKey()"/>-->
                    <!--&lt;!&ndash;</form>&ndash;&gt;-->
                <!--</div>-->
            </div>

            <div v-if="showPopup2" class="dv_popup_mail2" onclick="event.stopPropagation();">
                <div style="display: flex; width: 100%; justify-content: flex-end;">
                    <div style="width: 3vh; height: 3vh; margin-bottom: -3vh; z-index: 20; cursor: pointer;" @click.prevent.stop="closePopup()">
                        <img src="/static/imgs/ic_fechar.svg" style="background-color: var(--light-gray-font); width: 100%; height: 100%; padding: 0.5vh; margin-left: -0.5vh; margin-top: -0.5vh;"/>
                    </div>
                </div>
                <div id="popup2_ct" style="border-width: 2px; border-style: solid; border-color: var(--light-yellow); height: calc(100% - 4vh); text-align: left; padding: 2vh; display: flex; flex-direction: column; justify-content: space-between;">
                    <div>
                        <span class="tx_popup1">QUER RECEBER</span>
                        <div>
                            <span class="tx_popup1">MAIS</span>
                            <span class="tx_popup2_2">INFORMAÇÕES?</span>
                        </div>
                    </div>

                    <span class="tx_popup3">Através do nosso mailling, você receberá pacotes especiais e tarifas promocionais.</span>

                    <!--<form id="form_popup2">-->
                        <input class="ipt_popup" :placeholder="tx_digite_email" v-model="new_email" v-on:keyup.enter="closeKey()" onsubmit="closeKey()"/>
                    <!--</form>-->
                </div>
            </div>

            <div v-if="showPopup3" class="dv_popup_checkin" onclick="event.stopPropagation();">
                <div style="display: flex; width: 15%; height: 20%; cursor: pointer" @click.prevent.stop="closePopup()">
                </div>
                <a style="display: flex; width: 50%; height: 35%;" href="https://easycheckin.vegait.com.br/ls-hotel/ls-hotel" target="_blank">
                </a>
            </div>
        </div>

        <div class="overlay" @click="changeSideBar()"></div>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: 'Home',
    data () {
        return {
            name: 'Home',
            tx_historia_old: 'Inaugurado em 2018 como o primeiro hotel design de João Pessoa, o LS Hotel reúne luxo, conforto e exclusividade em um projeto de alto padrão, onde a combinação entre design e hotelaria lança um conceito único em hospedagem na capital paraibana. Conheça o requinte de nossa estrutura e os atrativos de nossos serviços, a experiência de se hospedar no LS Hotel com certeza irá lhe surpreender.',
            tx_historia: 'Reunindo luxo, conforto e exclusividade em um projeto de alto padrão, o LS Hotel nasce em 2018 como o primeiro hotel design de João Pessoa. Com uma proposta arrojada e serviços diferenciados, o hotel chega à capital paraibana com o compromisso de transformar hospedagens em grandes experiências.',
            tx_localizacao: 'Localizado em Manaíra, um dos mais nobres bairros de João Pessoa, o LS está a poucos passos da praia e próximo a diversas atrações turísticas, além de ter em seu entorno as melhores opcões em gastronomia, comércio e serviços.',
            tx_adega: 'Um dos mais tradicionais restaurantes de João Pessoa, a Adega fica localizada no LS Hotel. Em seu menu, pratos clássicos e contemporâneos da gastronomia portuguesa e internacional.',
            tx_ippon: 'Localizado no bairro de Tambaú, o Ippon conta com uma ambientação sofisticada, uma ampla área externa e um menu autoral, contemplando a cozinha japonesa e a fusion food.',
            tx_nonno: 'Com localização anexa ao LS Hotel, o Nonno Cucina apresenta uma cozinha italiana moderna e dinâmica, agregando aos seus pratos o valor e o sabor de ingredientes locais.',
            tx_pez: 'O PEZ Fish & Lounge chega ao rooftop do LS Hotel para abrilhantar ainda mais a experiência sensorial e gastronômica do espaço, proporcionando uma viagem à gastronomia peruana contemporânea.',
            tx_cassino: 'Fundado na década de 60, o Cassino da Lagoa passou a integrar o grupo gastronômico do LS Hotel com estrutura e menu repaginados, mas ainda preservando sua proposta clássica e emblemática.',
            tx_deluxe: 'Agradável suíte de 27 metros quadrados, com elegante decoração. Com uma cama de casal ou duas de solteiro, enxoval singular, amenities exclusivas, secador de cabelos, banheiro em mármore e minibar. Obras de arte compõem o ambiente.',
            tx_premium: 'Confortável suíte de 29 metros quadrados, com elegante decoração. Com uma cama de casal, amenities exclusivas, secador de cabelos, banheiro em mármore, minibar  e serviços de mordomia. Obras de arte compõem o ambiente.',
            tx_presidencial: 'Espaçosa suíte de 50 metros quadrados, com elegante decoração. Dispõe de automação de som, ar-condicionado e TV\'s. Com uma cama king size, enxoval elaborado sob medida, amenities personalizadas, secador de cabelos, banheiro em mármore com ofurô individual, chinelos personalizados, spa dos pés, minibar e serviços de mordomia. Obras de arte compõem o ambiente. Decoração romântica exclusiva para o pacote de núpcias - Sob consulta.',
            tx_digite_email: 'DIGITE AQUI SEU E-MAIL',
            logoHeight: 8,
            logoMargin: 1.5,
            sel_rest: 0,
            sel_acomodacao: 1,
            topBarMargin: 50,
            quantCriancas: 0,
            quantAdultos: 2,
            tipoSuite: 0,
            new_email: '',
            baseUrlApi: 'https://advice.domm.com.br:8445/AdviceServer/restapi/search/',
            // baseUrlApi: 'http://localhost:8082/AdviceServer/restapi/search/',
            showPopup: false,
            showPopup2: false,
            showPopup3: false,
            // esse
            showImagePopup: true,
            // esse
            primeiraVezPopup2: true,
            primeiraVezPopup3: true,
            meses: [
                'JANEIRO',
                'FEVEREIRO',
                'MARÇO',
                'ABRIL',
                'MAIO',
                'JUNHO',
                'JULHO',
                'AGOSTO',
                'SETEMBRO',
                'OUTUBRO',
                'NOVEMBRO',
                'DEZEMBRO'
            ],
            semanas: [
                'SEG',
                'TER',
                'QUA',
                'QUI',
                'SEX',
                'SAB',
                'DOM'
            ],
            calendario1: {
                mes: 10,
                dia: 10,
                ano: 2020,
                matrix: []
            },
            calendario2: {
                mes: 10,
                dia: 12,
                ano: 2020,
                matrix: []
            },
            slidesVec1: [],
            slidesVec2: [],
            slidesCur1: 1,
            slidesCur2: 1,
            slidesClickTime: 0,
            slidesAutoTime: 5000,
            slide_home: [
                '/static/imgs/bg_home02.jpg',
                // Quando tem o reveillon
                // '/static/imgs/bg_reveillon2023.jpg',
                // '/static/imgs/bg_sj_2023.jpg',
                '/static/imgs/bg_home01.jpg',
                // '/static/imgs/bg_home00.jpg',
                '/static/imgs/bg_home00_2023.jpg',
                // '/static/imgs/bg_home03.jpg'
                '/static/imgs/bg_home03_2023.jpg'
            ],
            slide_deluxe: [
                '/static/imgs/im_delux01.jpg',
                '/static/imgs/im_delux02.jpg',
                '/static/imgs/im_delux03.jpg'
            ],
            slide_premium: [
                '/static/imgs/im_premium01.jpg',
                '/static/imgs/im_premium02.jpg',
                '/static/imgs/im_premium03.jpg'
            ],
            slide_presidencial: [
                '/static/imgs/im_presidencial01.jpg',
                '/static/imgs/im_presidencial02.jpg',
                '/static/imgs/im_presidencial03.jpg'
            ],
            slide_suites: [
                '/static/imgs/im_delux01.jpg',
                '/static/imgs/im_delux02.jpg',
                '/static/imgs/im_delux03.jpg'
            ]
        }
    },
    methods: {
        SharpSpringForm (type, parentId) {
            // eslint-disable-next-line
            var ss_form = {'account': 'MzawMLE0NzQwBwA', 'ss_form': 'undefined'}
            ss_form.width = '100%'
            ss_form.domain = 'app-3QNV33B0SI.marketingautomation.services'
            if (type === 'FaleConosco') {
                ss_form.formID = 'M08xNTCxMDHRNTAxStQ1SUo11E1MTDTUNTZMSjK1TDY1NTIxBAA'
            } else if (type === 'Newsletter') {
                ss_form.formID = 'S05MSTGwMEvTNUo0T9I1sTAz1bVIszDQNTcyMzVJtUg1MjY3BgA'
            }

            // eslint-disable-next-line
            !function(e){var t,n,o,r,i,a,d,c,s,l=Math.random().toString(36).substring(7),m=document.referrer,h=[],u=function(){var i;if(parentId){if(!(i=document.getElementById(parentId)))return;if(i.getAttribute("ssformAdded"))return;i.setAttribute("ssformAdded",1)}else e.polling=!1;e.intervalId&&!e.polling&&(clearInterval(e.intervalId),e.intervalId=0);var a=function(e){if(e){var t=document.cookie.match("(^|;) ?"+e+"=([^;]*)(;|$)");return t?unescape(t[2]):null}return document.cookie}("__ss_tk");"http:"===window.location.protocol&&h.push("_noSsl=1"),a&&h.push("_tk="+a);var c=h.length?h.join("&"):"",m="instance="+l,u=["<iframe",'id="'+(s="ssf_"+n)+'"','data-form-id="'+n+'"','data-instance-id="'+l+'"','src="'+d+t+"/"+n+(""!==c?"?"+c+"&"+m:"?"+m)+'"','style="overflow-y: auto;"','frameborder="0"','height="'+(r||1e3)+'"','width="'+(o||500)+'"',"></iframe>"].join(" ");i?i.innerHTML=u:document.write(u),"function"!=typeof window.postMessage&&setInterval(function(){window.location.hash.match(/^#redirectURL=(.*)/)&&(window.top.location=RegExp.$1)},500)},f=function(e){var t=e.data;if(t&&"redirect"===t.action&&t.url){if("/"===t.url.charAt(0)){var o=document.createElement("a");if(o.href=window.top.location,"pages.services"===o.hostname){var r=o.pathname.split("/",2);2===r.length&&-1===t.url.indexOf(r[1])&&(t.url="/"+r[1]+t.url)}}window.top.location=t.url}else if(t&&t.formID&&t.formID===n&&(null===t.instanceID||void 0===t.instanceID||t.instanceID===l)){var i='[data-form-id="'+n+'"][data-instance-id="'+l+'"]';(c=document.querySelector(i))||(c=document.getElementById(s)),t.force?c.height=t.height||c.height:c.height=Math.max(t.height,c.height),c.parentNode&&(c.parentNode.style.minHeight=t.height+"px",c.parentNode.parentNode&&(c.parentNode.parentNode.style.minHeight=t.height+"px"))}};!function(){if(t=e.account,n=e.formID,o=e.width||"100%",r=200,i=e.domain,a=e.hidden,d="https://",t&&n&&i){if(d+=i?i+"/prospector/form/":"app.sharpspring.com/prospector/form/",a)for(var c in a)a.hasOwnProperty(c)&&h.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));m&&h.push("rf__sb="+encodeURIComponent(m)),void 0!==window.addEventListener?window.addEventListener("message",f,!1):void 0!==window.attachEvent&&window.attachEvent("onmessage",f),"complete"!==document.readyState&& parentId ?document.addEventListener?document.addEventListener("DOMContentLoaded",function(){e.intervalId=setInterval(function(){u()},100)}):document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&u()}):u()}else console&&console.warn&&console.warn("It seems that the embed code was not implemented correctly. ")}()}(ss_form);
        },
        SharpSpringPopup03 (parentId) {
            console.log('SharpSpringPopup03::inside')
            // <!-- SharpSpring Form for Pop-up Newsletter (TS)  -->
            // eslint-disable-next-line
            var ss_form = {'account': 'MzawMLE0NzQwBwA', 'formID': 'MzQ0tUwzSDbRNbRITtI1MUg10bUwMDLWTU4xsjS2MEk1MTdIAQA'} //  Newsletter Aniversário (Pop-up)
            // var ss_form = {'account': 'MzawMLE0NzQwBwA', 'formID': 'M0g1NUgzMkvWTTJJStY1MU410bU0N0rTtbRISTM2NbO0NLcwBAA'} // Newsletter (Pop-up)
            ss_form.width = '100%'
            ss_form.domain = 'app-3QNV33B0SI.marketingautomation.services'
            // ss_form.hidden = {'field_id': 'value'}; // Modify this for sending hidden variables, or overriding values
            ss_form.target_id = parentId // Optional parameter: forms will be placed inside the element with the specified id
            // ss_form.polling = true; // Optional parameter: set to true ONLY if your page loads dynamically and the id needs to be polled continually.
            // <script type="text/javascript" src="https://koi-3QNV33B0SI.marketingautomation.services/client/form.js?ver=2.0.1">

            // eslint-disable-next-line
            !function(e){var t,n,o,r,i,a,d,c,s,l=Math.random().toString(36).substring(7),m=document.referrer,h=[],u=function(){var i;if(e.target_id){if(!(i=document.getElementById(e.target_id)))return;if(i.getAttribute("ssformAdded"))return;i.setAttribute("ssformAdded",1)}else e.polling=!1;e.intervalId&&!e.polling&&(clearInterval(e.intervalId),e.intervalId=0);var a=function(e){if(e){var t=document.cookie.match("(^|;) ?"+e+"=([^;]*)(;|$)");return t?unescape(t[2]):null}return document.cookie}("__ss_tk");"http:"===window.location.protocol&&h.push("_noSsl=1"),a&&h.push("_tk="+a);var c=h.length?h.join("&"):"",m="instance="+l,u=["<iframe",'id="'+(s="ssf_"+n)+'"','data-form-id="'+n+'"','data-instance-id="'+l+'"','src="'+d+t+"/"+n+(""!==c?"?"+c+"&"+m:"?"+m)+'"','style="overflow-y: auto;"','frameborder="0"','height="'+(r||1e3)+'"','width="'+(o||500)+'"',"></iframe>"].join(" ");i?i.innerHTML=u:document.write(u),"function"!=typeof window.postMessage&&setInterval(function(){window.location.hash.match(/^#redirectURL=(.*)/)&&(window.top.location=RegExp.$1)},500)},f=function(e){var t=e.data;if(t&&"redirect"===t.action&&t.url){if("/"===t.url.charAt(0)){var o=document.createElement("a");if(o.href=window.top.location,"pages.services"===o.hostname){var r=o.pathname.split("/",2);2===r.length&&-1===t.url.indexOf(r[1])&&(t.url="/"+r[1]+t.url)}}window.top.location=t.url}else if(t&&t.formID&&t.formID===n&&(null===t.instanceID||void 0===t.instanceID||t.instanceID===l)){var i='[data-form-id="'+n+'"][data-instance-id="'+l+'"]';(c=document.querySelector(i))||(c=document.getElementById(s)),t.force?c.height=t.height||c.height:c.height=Math.max(t.height,c.height),c.parentNode&&(c.parentNode.style.minHeight=t.height+"px",c.parentNode.parentNode&&(c.parentNode.parentNode.style.minHeight=t.height+"px"))}};!function(){if(t=e.account,n=e.formID,o=e.width||"100%",r=200,i=e.domain,a=e.hidden,d="https://",t&&n&&i){if(d+=i?i+"/prospector/form/":"app.sharpspring.com/prospector/form/",a)for(var c in a)a.hasOwnProperty(c)&&h.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));m&&h.push("rf__sb="+encodeURIComponent(m)),void 0!==window.addEventListener?window.addEventListener("message",f,!1):void 0!==window.attachEvent&&window.attachEvent("onmessage",f),"complete"!==document.readyState&&e.target_id?document.addEventListener?document.addEventListener("DOMContentLoaded",function(){e.intervalId=setInterval(function(){u()},100)}):document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&u()}):u()}else console&&console.warn&&console.warn("It seems that the embed code was not implemented correctly. ")}()}(ss_form);
        },
        SharpSpringPopup1 (parentId) {
            // eslint-disable-next-line
            var __ss_noform = __ss_noform || []
            __ss_noform.push(['baseURI', 'https://app-3QNV33B0SI.marketingautomation.services/webforms/receivePostback/MzawMLE0NzQwBwA/'])
            __ss_noform.push(['form', '638d59b1-58f6-4b6b-87eb-21f350de0fc4'])

            // !function(e){var t="https://app.sharpspring.com/webforms/receivePostback/",n="",o={},r=!1,u=null,i=!1,a=null,c=!1,s={},l=/\[([^\[]*)\]/g,f=[];if(!window.__ss_noform||!window.__ss_noform.version){var m=function(){window.console&&window.console.warn&&console.warn("form err",arguments),f&&f.push(arguments)},d=function(e,t,n){if(!c){var o=!0;if("function"==typeof u&&!i)try{o=u(n)}catch(e){m("validation",e)}(o||void 0===o)&&function(e){e&&e.submit&&("function"==typeof e.submit?e.submit():document.createElement("form").submit.apply(e))}(t)}},p=function(e){var t=!1;switch(e.type){case"radio":case"checkbox":e.checked&&(t=e.value);break;default:t=e.value}return t},h=function(e,o,r,f){var h=f||a;try{if(e&&"function"==typeof e.preventDefault&&e.preventDefault(),i&&"function"==typeof u&&!u(e))return!1;(!h||e&&e.currentTarget&&"FORM"===e.currentTarget.tagName.toUpperCase())&&(h=e.currentTarget);var y,b,v,g,w=[],_=!1,k=[],E=null,T=!1,A={},C=function(e){if(!e)return null;var t=document.cookie.match("(^|;) ?"+e+"=([^;]*)(;|$)");return t?decodeURIComponent(t[2]):null}("__ss_tk");for(b=0;b<h.elements.length;b++)if(E=h.elements[b],T=!1,E.name&&!s.hasOwnProperty(E.name)&&"password"!==E.type){switch(A[y=E.name.replace(l,"_$1")]||(A[y]=[]),E.nodeName){case"INPUT":if(!1===(_=p(E)))continue;break;case"SELECT":if(E.multiple)for(k=[],T=!0,v=0;v<E.length;v++)E[v].selected&&k.push(encodeURIComponent(E[v].value));else _=E.value;break;case"TEXTAREA":_=E.value;break;default:continue}_&&A[y].push(T?k.join(","):encodeURIComponent(_))}for(g in A)A.hasOwnProperty(g)&&w.push(g+"="+A[g].join(","));C&&C.length&&w.push("trackingid__sb="+C);var I=!1,R=document.getElementsByTagName("head")[0]||document.documentElement,U=document.createElement("script");"default"===r&&(r=n);var B=w.join("&"),N=function(e){var t,n,o,r=1732584193,u=4023233417,i=[r,u,~r,~u,3285377520],a=[],c=[],s=unescape(encodeURI(e))+"Â€",l=s.length;for(c[e=--l/4+2|15]=8*l;~l;)c[l>>2]|=s.charCodeAt(l)<<8*~l--;for(t=l=0;t<e;t+=16){for(r=i;l<80;r=[r[4]+(a[l]=l<16?~~c[t+l]:2*s|s<0)+1518500249+[u&n|~u&o,s=341275144+(u^n^o),882459459+(u&n|u&o|n&o),s+1535694389][l++/5>>2]+((s=r[0])<<5|s>>>27),s,u<<30|u>>>2,n,o])s=a[l-3]^a[l-8]^a[l-14]^a[l-16],u=r[1],n=r[2],o=r[3];for(l=5;l;)i[--l]+=r[l]}for(s="";l<40;)s+=(i[l>>3]>>4*(7-l++)&15).toString(16);return s}(B);return U.src=t+r+"/jsonp/?"+B+"&__code="+N,U.onload=U.onreadystatechange=function(t){I||this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState||(c||setTimeout(function(){d(0,h,e)},500),"function"==typeof o&&o(h),I=!0)},R.insertBefore(U,R.firstChild),!1}catch(e){if(h){var P=""+e,O=document.createElement("input");e.stack&&(P+=" :: "+e.stack),O.setAttribute("type","hidden"),O.setAttribute("name","_ss_error"),O.setAttribute("class","ss_error"),O.setAttribute("value",encodeURIComponent(P)),h.appendChild(O)}return m(e,h,O),!0}},y=function(e,t){var n,i,s,l;if("string"==typeof parentId?(l=document.getElementById(parentId))&&(parentId=l):l=parentId,l){for(n=e.getElementsByTagName("input"),i=0;i<n.length;i++)"submit"===n[i].type&&n[i].onclick&&(u=n[i].onclick,n[i].onclick=null),"submit"===n[i].type&&n[i].name&&((s=document.createElement("input")).setAttribute("type","hidden"),s.setAttribute("name",n[i].name),s.setAttribute("value",n[i].value),e.appendChild(s));for(n=e.getElementsByTagName("button"),i=0;i<n.length;i++)"submit"===n[i].type&&n[i].onclick&&(u=n[i].onclick,n[i].onclick=null);c||("function"==typeof e.onsubmit&&(u=e.onsubmit,e.onsubmit=null),e.onsubmit=function(n){h(n,null,t,e)}),t&&(o[t]=e),t&&"default"!==t||(a=e),r=!0}else m("missing form",e)},b={baseURI:function(e){return t=e,!0},endpoint:function(e,t){return t?y(t,e):n=e,!0},validate:function(e){return u=e,i=!0,!0},submitType:function(e){return"manual"===e?(a&&(a.onsubmit=null),c=!0):c=!1,!0},form:function(e,t){return y(e,t||"default"),!0},submit:function(e,t){var r=a,u=t||"default";if(o[u]){var i=o[u]&&o[u].getAttribute("id");r=i&&document.getElementById(i)}return r&&h({currentTarget:r},e,u||n),!0},submitButton:function(){return!0},exclude:function(e){if(e&&"string"==typeof e)s[e]=1;else if(e&&e.length)for(var t in e)e.hasOwnProperty(t)&&(s[e[t]]=1)}},v=function(e){var t;try{do{(t=e.pop())&&b.hasOwnProperty(t[0])&&"function"==typeof b[t[0]]&&b[t[0]].apply(b[t[0]],t.slice(1))}while(t)}catch(e){m("setup",e)}return e.length};window.__ss_noform={errs:f,push:function(e){return v([e])},version:"1.25"},function(){var t,o;v(e);var u=document.forms,i=n;if(i||(i="default"),!r&&!a)for(o=0;o<u.length;o++)if("post"===(t=u[o]).method){y(t,i);break}}()}}(window.__ss_noform);
            // eslint-disable-next-line
            !function (e) {
                // eslint-disable-next-line
                var t = 'https://app.sharpspring.com/webforms/receivePostback/', n = '', o = {}, r = !1, u = null, i = !1, a = null, c = !1, s = {}, l = /\[([^\[]*)\]/g, f = []
                if (!window.__ss_noform || !window.__ss_noform.version) {
                    // eslint-disable-next-line
                    var m = function () {
                            // eslint-disable-next-line
                            window.console && window.console.warn && console.warn('form err', arguments), f && f.push(arguments)
                        }, d = function (e, t, n) {
                            if (!c) {
                                var o = !0
                                if (typeof u === 'function' && !i) {
                                    try {
                                        o = u(n)
                                    } catch (e) {
                                        m('validation', e)
                                    }
                                }
                                (o || void 0 === o) && (function (e) {
                                    e && e.submit && (typeof e.submit === 'function' ? e.submit() : document.createElement('form').submit.apply(e))
                                }(t))
                            }
                        }, p = function (e) {
                            var t = !1
                            switch (e.type) {
                            case 'radio':
                            case 'checkbox':
                                e.checked && (t = e.value)
                                break
                            default:
                                t = e.value
                            }
                            return t
                        }, h = function (e, o, r, f) {
                            var h = f || a
                            try {
                                // eslint-disable-next-line
                                if (e && typeof e.preventDefault === 'function' && e.preventDefault(), i && typeof u === 'function' && !u(e)) return !1;
                                // eslint-disable-next-line
                                (!h || e && e.currentTarget && e.currentTarget.tagName.toUpperCase() === 'FORM') && (h = e.currentTarget)
                                // eslint-disable-next-line
                                var y, b, v, g, w = [], _ = !1, k = [], E = null, T = !1, A = {}, C = (function (e) {
                                    if (!e) return null
                                    var t = document.cookie.match('(^|;) ?' + e + '=([^;]*)(;|$)')
                                    return t ? decodeURIComponent(t[2]) : null
                                }('__ss_tk'))
                                for (b = 0; b < h.elements.length; b++) {
                                    // eslint-disable-next-line
                                    if (E = h.elements[b], T = !1, E.name && !s.hasOwnProperty(E.name) && E.type !== 'password') {
                                        // eslint-disable-next-line
                                        switch (A[y = E.name.replace(l, '_$1')] || (A[y] = []), E.nodeName) {
                                        case 'INPUT':
                                            if (!1 === (_ = p(E))) continue
                                            break
                                        case 'SELECT':
                                            if (E.multiple) for (k = [], T = !0, v = 0; v < E.length; v++) E[v].selected && k.push(encodeURIComponent(E[v].value)); else _ = E.value
                                            break
                                        case 'TEXTAREA':
                                            _ = E.value
                                            break
                                        default:
                                            continue
                                        }
                                        _ && A[y].push(T ? k.join(',') : encodeURIComponent(_))
                                    }
                                }
                                for (g in A) A.hasOwnProperty(g) && w.push(g + '=' + A[g].join(','))
                                C && C.length && w.push('trackingid__sb=' + C)
                                // eslint-disable-next-line
                                var I = !1, R = document.getElementsByTagName('head')[0] || document.documentElement,
                                    U = document.createElement('script')
                                r === 'default' && (r = n)
                                // eslint-disable-next-line
                                var B = w.join('&'), N = (function (e) {
                                    // eslint-disable-next-line
                                    var t, n, o, r = 1732584193, u = 4023233417, i = [r, u, ~r, ~u, 3285377520], a = [], c = [], s = unescape(encodeURI(e)) + 'Â€', l = s.length
                                    for (c[e = --l / 4 + 2 | 15] = 8 * l; ~l;) c[l >> 2] |= s.charCodeAt(l) << 8 * ~l--
                                    for (t = l = 0; t < e; t += 16) {
                                        // eslint-disable-next-line
                                        for (r = i; l < 80; r = [r[4] + (a[l] = l < 16 ? ~~c[t + l] : 2 * s | s < 0) + 1518500249 + [u & n | ~u & o, s = 341275144 + (u ^ n ^ o), 882459459 + (u & n | u & o | n & o), s + 1535694389][l++ / 5 >> 2] + ((s = r[0]) << 5 | s >>> 27), s, u << 30 | u >>> 2, n, o]) s = a[l - 3] ^ a[l - 8] ^ a[l - 14] ^ a[l - 16], u = r[1], n = r[2], o = r[3]
                                        for (l = 5; l;) i[--l] += r[l]
                                    }
                                    for (s = ''; l < 40;) s += (i[l >> 3] >> 4 * (7 - l++) & 15).toString(16)
                                    return s
                                }(B))
                                // eslint-disable-next-line
                                return U.src = t + r + '/jsonp/?' + B + '&__code=' + N, U.onload = U.onreadystatechange = function (t) {
                                    // eslint-disable-next-line
                                    I || this.readyState && this.readyState !== 'loaded' && this.readyState !== 'complete' || (c || setTimeout(function () {
                                        d(0, h, e)
                                    }, 500), typeof o === 'function' && o(h), I = !0)
                                }, R.insertBefore(U, R.firstChild), !1
                            } catch (e) {
                                if (h) {
                                    // eslint-disable-next-line
                                    var P = '' + e, O = document.createElement('input')
                                    // eslint-disable-next-line
                                    e.stack && (P += ' :: ' + e.stack), O.setAttribute('type', 'hidden'), O.setAttribute('name', '_ss_error'), O.setAttribute('class', 'ss_error'), O.setAttribute('value', encodeURIComponent(P)), h.appendChild(O)
                                }
                                // eslint-disable-next-line
                                return m(e, h, O), !0
                            }
                        }, y = function (e, t) {
                            var n, i, s, l
                            // eslint-disable-next-line
                            if (typeof e === 'string' ? (l = document.getElementById(e)) && (e = l) : l = e, l) {
                                // eslint-disable-next-line
                                for (n = e.getElementsByTagName('input'), i = 0; i < n.length; i++) n[i].type === 'submit' && n[i].onclick && (u = n[i].onclick, n[i].onclick = null), n[i].type === 'submit' && n[i].name && ((s = document.createElement('input')).setAttribute('type', 'hidden'), s.setAttribute('name', n[i].name), s.setAttribute('value', n[i].value), e.appendChild(s))
                                // eslint-disable-next-line
                                for (n = e.getElementsByTagName('button'), i = 0; i < n.length; i++) n[i].type === 'submit' && n[i].onclick && (u = n[i].onclick, n[i].onclick = null)
                                // eslint-disable-next-line
                                c || (typeof e.onsubmit === 'function' && (u = e.onsubmit, e.onsubmit = null), e.onsubmit = function (n) {
                                    h(n, null, t, e)
                                    // eslint-disable-next-line
                                }), t && (o[t] = e), t && t !== 'default' || (a = e), r = !0
                            } else m('missing form', e)
                        }, b = {
                            baseURI: function (e) {
                                // eslint-disable-next-line
                                return t = e, !0
                            },
                            endpoint: function (e, t) {
                                // eslint-disable-next-line
                                return t ? y(t, e) : n = e, !0
                            },
                            validate: function (e) {
                                // eslint-disable-next-line
                                return u = e, i = !0, !0
                            },
                            submitType: function (e) {
                                // eslint-disable-next-line
                                return e === 'manual' ? (a && (a.onsubmit = null), c = !0) : c = !1, !0
                            },
                            form: function (e, t) {
                                // eslint-disable-next-line
                                return y(e, t || 'default'), !0
                            },
                            submit: function (e, t) {
                                // eslint-disable-next-line
                                var r = a, u = t || 'default'
                                if (o[u]) {
                                    var i = o[u] && o[u].getAttribute('id')
                                    r = i && document.getElementById(i)
                                }
                                // eslint-disable-next-line
                                return r && h({currentTarget: r}, e, u || n), !0
                            },
                            submitButton: function () {
                                return !0
                            },
                            exclude: function (e) {
                                if (e && typeof e === 'string') s[e] = 1; else if (e && e.length) for (var t in e) e.hasOwnProperty(t) && (s[e[t]] = 1)
                            }
                        }, v = function (e) {
                            var t
                            try {
                                do {
                                    (t = e.pop()) && b.hasOwnProperty(t[0]) && typeof b[t[0]] === 'function' && b[t[0]].apply(b[t[0]], t.slice(1))
                                } while (t)
                            } catch (e) {
                                m('setup', e)
                            }
                            return e.length
                        }
                    // eslint-disable-next-line
                    window.__ss_noform = {
                        errs: f,
                        push: function (e) {
                            return v([e])
                        },
                        version: '1.25'
                        // eslint-disable-next-line
                    }, (function () {
                        var t, o
                        v(e)
                        // eslint-disable-next-line
                        var u = document.forms, i = n
                        // eslint-disable-next-line
                        if (i || (i = 'default'), !r && !a) {
                            for (o = 0; o < u.length; o++) {
                                if ((t = u[o]).method === 'post') {
                                    y(t, i)
                                    break
                                }
                            }
                        }
                    }())
                }
            }(window.__ss_noform)
        },
        changeSideBar () {
            // console.log('entrei no changeSideBar')
            window.$('#icmenu').toggleClass('open')
            if (!window.$('#sidebar').hasClass('active')) {
                window.$('.overlay').fadeIn()
                window.$('.collapse.in').toggleClass('in')
                window.$('a[aria-expanded=true]').attr('aria-expanded', 'false')
            } else {
                window.$('.overlay').fadeOut()
            }
            window.$('#sidebar').toggleClass('active')
        },
        reservar () {
            var mes1 = '' + (this.calendario1.mes + 1)
            var mes2 = '' + (this.calendario2.mes + 1)
            if (mes1 < 10) {
                mes1 = '0' + (this.calendario1.mes + 1)
            }
            if (mes2 < 10) {
                mes2 = '0' + (this.calendario2.mes + 1)
            }
            var dia1 = this.calendario1.dia
            // console.log('dia1 len: ' + typeof dia1)
            // console.log('dia1 len: ' + dia1.size())
            var dia2 = this.calendario2.dia
            if (dia1 < 10) {
                dia1 = '0' + dia1
            }
            if (dia2 < 10) {
                dia2 = '0' + dia2
            }

            var dataIn = dia1 + mes1 + this.calendario1.ano
            var dataOut = dia2 + mes2 + this.calendario2.ano

            console.log('Datain ', dataIn)
            console.log('Dataout ', dataOut)

            var urlNewBusca = 'https://book.omnibees.com/hotelresults?c=4198&q=7482&NRooms=1&CheckIn=' + dataIn + '&CheckOut=' + dataOut + '&ad=' + this.quantAdultos + '&ch=' + this.quantCriancas
            var urlNewHome = 'https://book.omnibees.com/chain/4198?NRooms=1&CheckIn=' + dataIn + '&CheckOut=' + dataOut + '&ad=' + this.quantAdultos + '&ch=' + this.quantCriancas
            var urlOld = 'https://myreservations.omnibees.com/default.aspx?q=7482#/&diff=false&CheckIn=' + dataIn + '&CheckOut=' + dataOut + '&Code=&group_code=&loyality_card=&NRooms=1&ad=' + this.quantAdultos + '&ch=' + this.quantCriancas + '&ag=-'
            // https://myreservations.omnibees.com/default.aspx?q=7482#/&diff=false&CheckIn=02122020&CheckOut=19122020&Code=&group_code=&loyality_card=&NRooms=1&ad=1&ch=0&ag=-
            console.log('urlOld: ' + urlOld)
            console.log('urlNewHome: ' + urlNewHome)
            console.log('urlNewBusca: ' + urlNewBusca)

            // registra o clique no botao de reserva.
            this.callAnalytics('jwErCJa10L8ZEKTFz98q')

            this.goToURL(urlNewBusca)
        },
        callWhatsApp () {
            this.callAnalytics('8fZ_CKqN0L8ZEKTFz98q')
            this.goToURL('https://wa.me/+558391951687')
        },
        callAnalytics (code) {
            console.log('Entrei no call Analytics', code)
            window.gtag('event', 'conversion', {
                'send_to': 'AW-11474821796/' + code
            })
            console.log('Sai no call Analytics', code)
        },
        closePopup () {
            if (this.showPopup) {
                this.showPopup = false
            }
            if (this.showPopup2) {
                this.showPopup2 = false
            }
            if (this.showPopup3) {
                this.showPopup3 = false
            }
            if (this.showImagePopup) {
                this.showImagePopup = false
            }
        },
        closeKey () {
            console.log('closeKeyboard')
            this.sendNewsletter()
        },
        selectRestaurante (i) {
            this.sel_rest = i
        },
        selectAcomodacao (i) {
            this.sel_acomodacao = i
            switch (i) {
            case 1: this.slide_suites = this.slide_deluxe; break
            case 2: this.slide_suites = this.slide_premium; break
            case 3: this.slide_suites = this.slide_presidencial; break
            }
        },
        selectMenu (i, changeSideBar) {
            console.log('selectMenu: ' + i)
            var target
            switch (i) {
            case 0:
                target = document.getElementById('part0')
                break
            case 1:
                target = document.getElementById('part1')
                break
            case 2:
                target = document.getElementById('part2')
                break
            case 3:
                target = document.getElementById('part3')
                break
            case 4:
                target = document.getElementById('part4')
                break
            case 5:
                target = document.getElementById('part5')
                break
            case 6:
                target = document.getElementById('part6')
                break
            case 7:
                this.$router.push({name: 'Blog'})
                break
            default:
                target = document.getElementById('part0')
            }

            if (this.isMobile() && changeSideBar === undefined) {
                this.changeSideBar()
            }

            window.$('html,body').animate({
                scrollTop: target.offsetTop},
            'slow')
        },
        addEvent (obj, type, fn) {
            if (obj.attachEvent) {
                obj['e' + type + fn] = fn
                obj[type + fn] = function () { obj['e' + type + fn](window.event) }
                obj.attachEvent('on' + type, obj[type + fn])
            } else {
                obj.addEventListener(type, fn, false)
            }
        },
        isMobile () {
            if (window.innerWidth < 861) {
                return true
            } else {
                return false
            }
        },
        handleScrool (event) {
            // console.log('el.scrollHeight ', this.elPart0.scrollHeight)
            // console.log('event ', window.scrollY)
            // var vm = this

            if (window.scrollY > (this.elPart2.offsetTop - this.elPart2.scrollHeight / 2) && this.primeiraVezPopup3 && !this.showPopup) {
                // console.log('entrei')
                this.primeiraVezPopup3 = false
                this.showPopup3 = true
            }

            // console.log('w: ', window.scrollY, this.elPart5.scrollHeight, this.elPart5.offsetTop)
            if (window.scrollY > (this.elPart5.offsetTop - this.elPart5.scrollHeight / 2) && this.primeiraVezPopup2 && !this.showPopup && !this.showPopup3) {
                // console.log('entrei')

                // Cancelado temporariamente
                // this.primeiraVezPopup2 = false
                // this.showPopup2 = true

                // setTimeout(function () {
                //     vm.SharpSpringPopup1('form_popup2')
                // this.SharpSpringPopup03('form_popup2')
                // }, 500)
            }

            if (this.isMobile()) {
                this.logoHeight = 5
                this.topBarMargin = 0
                this.logoMargin = 0
                return
            }

            if (window.scrollY > this.elPart0.scrollHeight) {
                this.topBarMargin = 0
                this.logoHeight = 5
                this.logoMargin = 0
            } else {
                let diff = this.elPart0.scrollHeight - window.scrollY
                this.topBarMargin = Math.round(diff * 0.05)
                let p = diff / this.elPart0.scrollHeight
                this.logoHeight = 4 + 4 * p
                this.logoMargin = 1.5 * p
                // console.log('this.elPart0.scrollHeight: ', this.elPart0.scrollHeight)
                // console.log('window.scrollY: ', window.scrollY)
                // console.log('diff: ', diff)
                // console.log('percentual: ', p)
            }
            // console.log('logoHeight: ', this.logoHeight)
            // console.log('logoMargin: ', this.logoMargin)
        },
        goToURL (url) {
            window.open(url, '_blank')
            // location.href = url
        },
        goToPage (page) {
            this.closePopup()
            this.$router.push({name: page})
        },
        sendNewsletter () {
            var vw = this

            console.log('sendNewsletter ' + this.new_email)
            if (!this.checkEmail()) {
                alert('Endereço de e-mail inválido.')
            } else {
                var url = this.baseUrlApi + 'addnewsletter'

                var data = {
                    'email': this.new_email,
                    idlocal: 100
                }

                // console.log('Enviando post com o newsletter: ' + url)
                // console.log('data: ', data)
                axios.post(url, qs.stringify(data))
                    .then(function (response) {
                        // vm.loading.form = false;
                        console.log('SUCESS::' + response)
                        vw.closePopup()
                    })
                    .catch(function (error) {
                        // vm.loading.form = false;
                        console.log('ERROR::' + error)
                    })

                // LS Server
                data = {
                    'email': this.new_email
                }
                url = 'https://mail.lshotel.com.br/newsletter.php'
                // console.log('Enviando post com o newsletter2: ' + url)
                // console.log('data2: ', data)
                axios.post(url, qs.stringify(data))
                    .then(function (response) {
                        // vm.loading.form = false;
                        console.log('SUCESS::' + response)
                    })
                    .catch(function (error) {
                        // vm.loading.form = false;
                        console.log('ERROR::' + error)
                    })

                this.sleep(1000).then(() => {
                    alert('Que bom que você está conosco, aproveite a viagem!')

                    vw.closePopup()
                })
            }
        },
        checkEmail () {
            var email = this.new_email
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        sleep (time) {
            return new Promise((resolve) => setTimeout(resolve, time))
        },
        getMes (calendario, i) {
            // console.log('Entreino getMes: ', calendario, i)

            if (i === 1) {
                calendario.mes++
                if (calendario.mes > 11) {
                    calendario.mes = 0
                    calendario.ano++
                }
            } else if (i === -1) {
                calendario.mes--
                if (calendario.mes < 0) {
                    calendario.mes = 11
                    calendario.ano--
                }
            }

            if (i !== 0) {
                calendario.matrix = this.generateCalendarMatrix(calendario)
                this.selectIntervalo(this.calendario1, this.calendario2)
            }

            return this.meses[calendario.mes]
        },
        generateDiasVector (mes, ano) {
            var dt = new Date(ano, mes, 28)
            // todo mes tem no minimo 28 dias
            var v = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            var i
            for (i = 29; i <= 31; i++) {
                dt.setDate(dt.getDate() + 1)
                if (dt.getMonth() === mes) {
                    v.push(i)
                } else {
                    break
                }
            }

            return v
        },
        generateCalendarMatrix (calendario) {
            var matrix = []
            var i, j
            for (i = 0; i < 6; i++) {
                matrix[i] = new Array(7)
            }

            var daysVector = this.generateDiasVector(calendario.mes, calendario.ano)

            for (j = 0; j < 6; j++) {
                for (i = 0; i < 7; i++) {
                    matrix[j][i] = {
                        dia: '',
                        el: null
                    }
                }
            }

            var dt = new Date(calendario.ano, calendario.mes, 1)
            // dia semana
            var ds = dt.getDay() - 1
            if (ds < 0) {
                ds = 6
            }

            var iv = 0

            for (i = ds; i < 7; i++) {
                matrix[0][i].dia = daysVector[iv]
                iv++
                if (iv >= daysVector.length) {
                    break
                }
            }

            for (j = 1; j < 6; j++) {
                for (i = 0; i < 7; i++) {
                    matrix[j][i].dia = daysVector[iv]
                    iv++
                    if (iv >= daysVector.length) {
                        return matrix
                    }
                }
            }

            // var linha
            // for (j = 0; j < 6; j++) {
            //     linha = ''
            //     for (i = 0; i < 7; i++) {
            //         linha += ' ' + matrix[j][i].dia
            //     }
            //     console.log('linha: ' + linha)
            // }

            return matrix
        },
        prepareCalendar () {
            var dt = new Date()

            // console.log('dia sem: ', dt.getDay())
            // console.log('dia: ', dt.getDate())
            // console.log('mes: ', dt.getMonth())
            // console.log('ano: ', dt.getFullYear())

            this.calendario1.dia = dt.getDate()
            this.calendario1.mes = dt.getMonth()
            this.calendario1.ano = dt.getFullYear()
            this.calendario1.matrix = this.generateCalendarMatrix(this.calendario1)

            // TODO botar + 2
            dt.setDate(dt.getDate() + 3)

            // console.log('Preparando calendario 2')
            this.calendario2.dia = dt.getDate()
            this.calendario2.mes = dt.getMonth()
            this.calendario2.ano = dt.getFullYear()
            // console.log('Preparado calendario 2', this.calendario2)
            this.calendario2.matrix = this.generateCalendarMatrix(this.calendario2)

            // console.log('Preparado calendario 2')
        },
        selectDay (calendarioNum, row, col) {
            console.log('selectDay: ', calendarioNum, row, col)
            // var id = calendarioNum + ',' + row + ',' + col
            var calendario
            if (calendarioNum === 1) {
                calendario = this.calendario1
            } else {
                calendario = this.calendario2
            }

            // console.log('calendario.matrix[row - 1][col - 1]: ', calendario.matrix[row - 1][col - 1].dia)
            if (calendario.matrix[row - 1][col - 1].dia === '') {
                return
            }

            calendario.dia = calendario.matrix[row - 1][col - 1].dia

            this.selectIntervalo(this.calendario1, this.calendario2)
        },
        selectIntervalo (c1, c2) {
            // console.log('selectIntervalo::entrei: ', c1, c2)
            var i, j
            var mesmoMes = false
            if (c1.mes === c2.mes) {
                mesmoMes = true
            }
            // console.log('selectIntervalo::mesmoMes: ', mesmoMes)

            var ca = c1
            var ind = 1
            for (j = 0; j < 6; j++) {
                for (i = 0; i < 7; i++) {
                    if (ca.matrix[j][i].el == null) {
                        let id = ind + ',' + (j + 1) + ',' + (i + 1)
                        ca.matrix[j][i].el = document.getElementById(id)
                    }

                    if (ca.matrix[j][i].dia === ca.dia) {
                        ca.matrix[j][i].el.className = 'tb_reserva_s'
                    } else if (ca.matrix[j][i].dia === '') {
                        ca.matrix[j][i].el.className = 'tb_reserva'
                    } else
                    if (mesmoMes) {
                        if (ca.matrix[j][i].dia >= c1.dia && ca.matrix[j][i].dia <= c2.dia) {
                            ca.matrix[j][i].el.className = 'tb_reserva_i'
                        } else {
                            ca.matrix[j][i].el.className = 'tb_reserva'
                        }
                    } else {
                        /* MAIOR que o dia */
                        if (ca.matrix[j][i].dia >= ca.dia) {
                            ca.matrix[j][i].el.className = 'tb_reserva_i'
                        } else {
                            ca.matrix[j][i].el.className = 'tb_reserva'
                        }
                    }
                }
            }

            ca = c2
            ind = 2
            for (j = 0; j < 6; j++) {
                for (i = 0; i < 7; i++) {
                    if (ca.matrix[j][i].el == null) {
                        let id = ind + ',' + (j + 1) + ',' + (i + 1)
                        ca.matrix[j][i].el = document.getElementById(id)
                    }

                    if (ca.matrix[j][i].dia === ca.dia) {
                        ca.matrix[j][i].el.className = 'tb_reserva_s'
                    } else if (ca.matrix[j][i].dia === '') {
                        ca.matrix[j][i].el.className = 'tb_reserva'
                    } else
                    if (mesmoMes) {
                        if (ca.matrix[j][i].dia >= c1.dia && ca.matrix[j][i].dia <= c2.dia) {
                            ca.matrix[j][i].el.className = 'tb_reserva_i'
                        } else {
                            ca.matrix[j][i].el.className = 'tb_reserva'
                        }
                    } else {
                        /* menor que o dia */
                        if (ca.matrix[j][i].dia <= ca.dia) {
                            ca.matrix[j][i].el.className = 'tb_reserva_i'
                        } else {
                            ca.matrix[j][i].el.className = 'tb_reserva'
                        }
                    }
                }
            }
        },
        moveSlide (index, right, manualClick = true) {
            // console.log('moveSlide' + index)
            var currTime = Date.now()
            var slidesVec
            var slidesCur
            if (manualClick) {
                this.bannerAutoSlide = true
            }

            if (currTime - this.slidesClickTime < 700) {
                console.log('moveSlide::return because time interval is too short')
                return
            }

            if (!manualClick && (currTime - this.slidesClickTime < this.slidesAutoTime)) {
                console.log('moveSlide::tempo de espera errado.')
                return
            }

            if (!this.bannerAutoSlide) {
                console.log('moveSlide::Nao eh para momento do auto slide.')
                return
            }

            if (index === 1) {
                slidesVec = this.slidesVec1
                slidesCur = this.slidesCur1
            } else {
                slidesVec = this.slidesVec2
                slidesCur = this.slidesCur2
            }

            this.slidesClickTime = currTime

            // console.log('moveSlide::Movendo slide para: ' + right + ', manualClick: ' + manualClick + ', bannerAutoSlide: ' + this.bannerAutoSlide + ', ' + this.name)
            // Get all the slides again
            var slides = window.$('.slide' + index)
            // console.log('slides: ', slides)

            // Register active slide
            // var activeSlide = $('.active');
            var activeSlide = slidesVec[slidesCur]

            // Next function
            if (right) {
                slidesCur = (slidesCur + 1) % slidesVec.length

                // Move first slide to the end so the user can keep going forward
                slides.last().after(slides.first())
                // Move active class to the right
                activeSlide.removeClass('active').next('.slide' + index).addClass('active')
            } else {
                slidesCur--
                if (slidesCur < 0) {
                    slidesCur = slidesVec.length - 1
                }

                // Move the last slide before the first so the user can keep going backwards
                slides.first().before(slides.last())
                // Move active class to the left
                activeSlide.removeClass('active').prev('.slide' + index).addClass('active')
            }

            if (index === 1) {
                this.slidesVec1 = slidesVec
                this.slidesCur1 = slidesCur
            } else {
                this.slidesVec2 = slidesVec
                this.slidesCur2 = slidesCur
            }

            if (this.bannerAutoSlide) {
                var vm = this
                setTimeout(function () {
                    if (vm.name === 'Home') {
                        vm.moveSlide(index, true, false)
                    }
                }, vm.slidesAutoTime)
            }
        },
        prepareSlider () {
            // Get all the slides again
            // Home
            var vec = window.$('.slide1')
            this.slidesVec1.push(vec.first())
            this.slidesVec1.push(vec.first().next())
            this.slidesVec1.push(vec.first().next().next())
            // Quando tem o reveillon
            // this.slidesVec1.push(vec.first().next().next().next()) // quando tem o Reveillon
            this.slidesVec1.push(vec.last())

            // Get all the slides again
            // ACOMODACOES
            vec = window.$('.slide2')
            this.slidesVec2.push(vec.first())
            this.slidesVec2.push(vec.first().next())
            this.slidesVec2.push(vec.last())

            // console.log('this.slidesVec: ', this.slidesVec)

            // this.mobile = this.isMobile()

            var vm = this
            setTimeout(function () {
                vm.moveSlide(1, true, true)
            }, vm.slidesAutoTime * 2)
        }
    },
    created () {
        this.prepareCalendar()
        console.log('Saindo do Created')

        if (this.isMobile()) {
            this.logoHeight = 5
            this.topBarMargin = 0
            this.logoMargin = 0

            // Quando tem o reveillon
            // this.slide_home[1] = '/static/imgs/bg_reveillon2023_m2.jpg'
            // this.slide_home[1] = '/static/imgs/bg_reveillon2024.jpg'
        }
    },
    mounted () {
        console.log('Entrando do Mounted')
        global.jQuery = require('jquery')
        window.$ = global.jQuery
        // var vm = this

        this.elPart0 = document.getElementById('part0')
        this.elPart2 = document.getElementById('part2')
        this.elPart5 = document.getElementById('part5')

        if (this.isMobile()) {
            this.logoHeight = 5
            this.topBarMargin = 0
            this.logoMargin = 0
        } else {
            this.topBarMargin = Math.round(this.elPart0.scrollHeight * 0.05)
            this.logoHeight = 8
            this.logoMargin = 1.5
        }

        this.addEvent(window, 'scroll', this.handleScrool)
        this.addEvent(document.body, 'touchmove', this.handleScrool)

        this.selectIntervalo(this.calendario1, this.calendario2)

        this.prepareSlider()

        if (this.$route.params.menuIndex != null) {
            this.selectMenu(this.$route.params.menuIndex)
            this.showPopup = false
            this.primeiraVezPopup2 = false
        }

        this.SharpSpringForm('FaleConosco', 'faleconosco_ct')
        this.SharpSpringForm('Newsletter', 'newsletter_ct')
        // this.SharpSpringPopup03('popup1_ct')
        // this.SharpSpringPopup1('form_popup2')
        // let externalScript = document.createElement('script')
        // externalScript.setAttribute('src', 'https://koi-3QNV33B0SI.marketingautomation.services/client/form.js?ver=2.0.1')
        // // document.head.appendChild(externalScript)
        // document.getElementById('reservar_ct').appendChild(externalScript)

        console.log('Saindo do Mounted')
    }
}
</script>

<style src="../assets/css/side_bar.css" scoped/>
<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/ls.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue